import Picture from './picture'

export default Picture
